<template>
  <c-header />
  <router-view/>
  <c-footer />
</template>


